import { INITIALIZE_AUTH_EMAILS_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[INITIALIZE_AUTH_EMAILS_FORM](values);
